module.exports = __webpack_public_path__ + "assets/8d762169361d973d8a3245b9bb2c5e66.mp4";